<div
  class="offcanvas offcanvas-end"
  data-bs-backdrop="default"
  tabindex="-1"
  id="staticBackdrop"
  aria-labelledby="staticBackdropLabel">
  <div class="offcanvas-header">
    <h1 class="offcanvas-title" id="staticBackdropLabel">Mandat: #{{ current_mandat?.Md_BelegNr }}</h1>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" (click)="closePreview()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
        <path
          fill-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"
          clip-rule="evenodd" />
      </svg>
    </button>
  </div>
  <div class="offcanvas-body">
    <app-mandat-preview *ngIf="previewMandatId" [mandatId]="previewMandatId"></app-mandat-preview>
  </div>
</div>

<div class="d-flex">
  <div class="row setting-card-container mx-auto">
    <mat-card class="mat-elevation-z4 w-100">
      <mat-card-title>VSTV</mat-card-title>
      <mat-card-content>
      <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
        <!--
          ------------------------------------------------------------
          AKTUELLES PAKET
        -->
        <mat-tab label="Aktuelles Paket">
          <div class="mx-4" *ngIf="!showNoResults">
            <div
              *ngIf="isLoading"
              style="display: flex; justify-content: center; align-items: center; background: white">
              <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
            </div>

            <mat-form-field appearance="standard">
              <mat-label>Suche Aktenzeichen</mat-label>
              <input matInput (keyup)="applyFilter($event)" [(ngModel)]="searchValue" placeholder="" #input />
              <button
                mat-button
                *ngIf="searchValue"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="searchValue = ''; applyFilter($event)">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div class="example-container">
            <app-empty-state
              *ngIf="showNoResults"
              title="Keine Mandate für den Export"
              text="Derzeit sind keine überfälligen Mandate für den VSTV-Export vorhanden. Bereits exportierte Pakete finden Sie im Archiv."
              buttonLabel="Zum Archiv"
              (action)="goToArchiveTab()">
            </app-empty-state>

            <table
              [hidden]="showNoResults"
              mat-table
              [dataSource]="dataSource"
              class="mat-elevation-z0"
              matSort
              matSortActive="Md_PrimKey"
              matSortDisableClear
              matSortDirection="desc"
              matTableExporter
              #exporter="matTableExporter">
              <!----------------------------------------------------------------- -->

              <!-- Select Checkbox Column -->
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef style="padding: 8px 12px; width: 48px;">
                  <mat-checkbox
                    (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" style="padding: 8px 12px; width: 48px;">
                  <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)">
                  </mat-checkbox>
                </td>
              </ng-container>

              <!-- ID Column -->
              <ng-container matColumnDef="Md_PrimKey">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
                <td mat-cell *matCellDef="let row">{{ row.Md_PrimKey }}</td>
              </ng-container>

              <!-- Md_Status Column -->
              <ng-container matColumnDef="Md_Status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-100">Status</th>
                <td mat-cell *matCellDef="let row">
                  <div
                    *ngIf="row.Md_Status == 'A'"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-approved word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    ANGEZEIGT
                  </div>

                  <div
                    *ngIf="row.Md_Status == 'T'"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-gray [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    TEIL-ERFASST
                  </div>

                  <div
                    *ngIf="row.Md_Status == 'E'"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-darkgray [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    ERFASST
                  </div>

                  <div
                    *ngIf="row.Md_Status == 'U'"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-overdue [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    ÜBERFÄLLIG
                  </div>

                  <div
                    *ngIf="row.Md_Status == 'B'"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-active-fsdone [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    BEZAHLT
                  </div>

                  <div
                    *ngIf="row.Md_Status == 'AB'"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-warn [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    ANG/BEZ
                  </div>

                  <div
                    *ngIf="row.Md_Status == 'S'"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-lightgray [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    STORNO
                  </div>

                  <div
                    *ngIf="row.Md_Status == '8'"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-warn [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    AUSGENOMMEN
                  </div>

                  <div
                    *ngIf="row.Md_Status == '9'"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-error [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    ERROR
                  </div>
                </td>
              </ng-container>

              <!-- Profilbild Column
              <ng-container matColumnDef="profile_image">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-50">&nbsp;</th>
                <td mat-cell *matCellDef="let row">
                  <phuture-iavatar src_image="{{ imageStorage }}{{ row.profile_image }}"></phuture-iavatar>
                </td>
              </ng-container>
              -->

              <!-- Md_BelegNr Column -->
              <ng-container matColumnDef="Md_BelegNr">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-100">Aktenzeichen</th>
                <td mat-cell *matCellDef="let row" class="font-semibold">&nbsp;{{ row.Md_BelegNr }}&nbsp;</td>
              </ng-container>

              <!-- bom Column -->
              <ng-container matColumnDef="bom">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-80">BOM</th>
                <td mat-cell *matCellDef="let row">
                  <div
                    *ngIf="row.bom == 1"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-bom [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#4caf50] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-white shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#388e3c] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    BOM
                  </div>
                  <div
                    *ngIf="row.bom == 0 || !row.bom"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-anzeige [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#2196f3] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-white shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#1976d2] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    Anzeige
                  </div>
                </td>
              </ng-container>

              <!----------------------------------------------------------------- -->

              <!-- Md_StatusDate Column -->
              <ng-container matColumnDef="Md_StatusDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Datum</th>
                <td mat-cell *matCellDef="let row">&nbsp;{{ row.Md_StatusDate | date }}&nbsp;</td>
              </ng-container>

              <!-- Md_StatusTime Column -->
              <ng-container matColumnDef="Md_StatusTime">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Zeit</th>
                <td mat-cell *matCellDef="let row">&nbsp;{{ row.Md_StatusTime | date : 'shortTime' }}&nbsp;</td>
              </ng-container>

              <!-- Md_KzLand Column -->
              <ng-container matColumnDef="Md_KzLand">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Land</th>
                <td mat-cell *matCellDef="let row">&nbsp;{{ row.Md_KzLand }}&nbsp;</td>
              </ng-container>

              <!-- Md_KzBezirk Column -->
              <ng-container matColumnDef="Md_KzBezirk">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Bezirk</th>
                <td mat-cell *matCellDef="let row">{{ row.Md_KzBezirk }}</td>
              </ng-container>

              <!-- Md_KzNummer Column -->
              <ng-container matColumnDef="Md_KzNummer">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Kennzeichen</th>
                <td mat-cell *matCellDef="let row">{{ row.Md_KzNummer }}</td>
              </ng-container>

              <!-- Md_Hersteller Column -->
              <ng-container matColumnDef="Md_Hersteller">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-100">Hersteller</th>
                <td mat-cell *matCellDef="let row">{{ row.Md_Hersteller }}</td>
              </ng-container>

              <!-- VSTV Code Column -->
              <ng-container matColumnDef="Md_TatbestNr">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>VSTV Code</th>
                <td mat-cell *matCellDef="let row">{{ formatVSTVCode(row.Md_TatbestNr) }}</td>
              </ng-container>

              <!-- Md_Betrag Column -->
              <ng-container matColumnDef="Md_Betrag">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Betrag</th>
                <td mat-cell *matCellDef="let row">{{ row.Md_Betrag }}</td>
              </ng-container>

              <!-- Person Column -->
              <ng-container matColumnDef="person">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-100">Person</th>
                <td mat-cell *matCellDef="let row">{{ row.person }}</td>
              </ng-container>

              <!----------------------------------------------------------------- -->

              <!-- actions button bar Column
            -->

              <ng-container matColumnDef="actions" stickyEnd>
                <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
                <td mat-cell *matCellDef="let row">
                  <!--
                  <button mat-icon-button [matMenuTriggerFor]="appMenu">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #appMenu="matMenu">
                    <button mat-menu-item (click)="ausPaketAusnehmen(row)">Aus Paket ausnehmen</button>
                  </mat-menu>
                --></td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let emprow; columns: displayedColumns"
                (click)="openPreview(emprow.Md_PrimKey)"
                style="cursor: pointer"></tr>
            </table>

            <mat-paginator
              #paginator
              [hidden]="showNoResults"
              [length]="totalItems"
              [pageSizeOptions]="pageSizes"
              showFirstLastButtons></mat-paginator>
          </div>

          <p *ngIf="!showNoResults">&nbsp;</p>

          <div *ngIf="!showNoResults">
            <form [formGroup]="frmExport">
              <div class="flex items-center space-x-2">
                <!--
                <mat-form-field>
                  <mat-label>Anzahl Mandate</mat-label>
                  <mat-select>
                    <mat-option *ngFor="let size of patchsize" [value]="size.viewValue">
                      {{ size.viewValue }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
-->
                <label for="bearbeiter" class="mr-2">Bearbeiter:</label>
                <input
                  type="text"
                  class="form-input bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-1/3 p-2.5"
                  id="bearbeiter"
                  formControlName="bearbeiter"
                  placeholder="Bearbeiter" />
              </div>

              <button
                *ngIf="false"
                type="button"
                matRipple
                class="mt-4 bg-blue-400 hover:bg-blue-700 text-white py-2 px-4"
                (click)="generateVSTV(0)">
                VSTV exportieren
              </button>

              <button
                type="button"
                matRipple
                class="mt-4 ml-2 text-white py-2 px-4"
                style="background-color: rgb(89, 151, 111); border: none; border-radius: 4px; cursor: pointer;"
                onmouseover="this.style.backgroundColor='rgb(65, 120, 85)'"
                onmouseout="this.style.backgroundColor='rgb(89, 151, 111)'"
                (click)="generateVSTV25(0)">
                VSTV v25 exportieren
                <span *ngIf="selection.selected.length > 0">({{ selection.selected.length }} ausgewählt)</span>
                <span *ngIf="selection.selected.length === 0">(alle)</span>
              </button>

              <span *ngIf="selection.selected.length > 0" class="ml-4 text-sm text-gray-600" style="vertical-align: middle;">
                {{ selection.selected.length }} von {{ dataSource.data.length }} Mandate ausgewählt
              </span>
            </form>
          </div>

          <p>&nbsp;</p>

          <div *ngIf="vstvlog != '' && !erneutDownload" class="logVSTVExport checkJournal">
            <p [innerHTML]="vstvlog"></p>

            <button
              type="button"
              matRipple
              [matRippleColor]="'rgb(103, 121, 189, 0.5)'"
              class="bg-blue-400 hover:bg-blue-700 text-white py-2 px-4"
              [style]="{ 'margin-left': '.5em' }"
              (click)="downloadVSTV(paketID)">
              VSTV Datei herunterladen
            </button>
          </div>

          <div *ngIf="vstv25log != '' && !erneutDownload25" class="logVSTVExport checkJournal">
            <p [innerHTML]="vstv25log"></p>

            <button
              type="button"
              matRipple
              [matRippleColor]="'rgb(103, 121, 189, 0.5)'"
              class="text-white py-2 px-4"
              style="background-color: rgb(89, 151, 111); border: none; border-radius: 4px; cursor: pointer; margin-left: .5em;"
              onmouseover="this.style.backgroundColor='rgb(65, 120, 85)'"
              onmouseout="this.style.backgroundColor='rgb(89, 151, 111)'"
              (click)="downloadVSTV25(paketID)">
              VSTV25 XML Datei herunterladen
            </button>
          </div>

          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </mat-tab>

        <!--
          ------------------------------------------------------------
          ARCHIV
        -->
        <mat-tab label="Archiv"
          ><p>&nbsp;</p>
          <p>Liste der bereits &uuml;bermittelten VSTV Pakete.</p>

          <div class="flex items-center space-x-2 mr-4">
            <select
              class="form-control"
              id="allVSTVPakete"
              [formControl]="popVSTVArchiv"
              class="mb-2 py-2 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-4/5 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
              <option value="" disabled selected>Bitte wählen Sie ein Paket aus.</option>
              <option *ngFor="let paket of vstv_archiv_pakete | sort : 'created' : 'desc'" [value]="paket?.id">
                #{{ paket?.id }} | {{ paket?.bezeichnung }} - erstellt:
                {{ paket?.created | date : 'dd.MM.yyyy HH:mm:ss' }}
              </option>
            </select>
          </div>

          <div class="example-container">
            <app-empty-state
              *ngIf="showArchivNoPaketSelected"
              icon="folder_open"
              title="Kein Paket ausgewählt"
              text="Bitte wählen Sie oben ein VSTV-Paket aus dem Archiv aus, um die enthaltenen Mandate anzuzeigen.">
            </app-empty-state>

            <table
              [hidden]="showArchivNoPaketSelected"
              mat-table
              [dataSource]="dsVSTVArchivMandate"
              class="mat-elevation-z0"
              matSort
              matSortActive="Md_PrimKey"
              matSortDisableClear
              matSortDirection="desc"
              matTableExporter
              #exporter="matTableExporter">
              <!----------------------------------------------------------------- -->

              <!-- ID Column -->
              <ng-container matColumnDef="Md_PrimKey">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
                <td mat-cell *matCellDef="let row">{{ row.Md_PrimKey }}</td>
              </ng-container>

              <!-- Md_Status Column -->
              <ng-container matColumnDef="Md_Status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-100">Status</th>
                <td mat-cell *matCellDef="let row">
                  <div
                    *ngIf="row.Md_Status == 'A'"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-approved word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    ANGEZEIGT
                  </div>

                  <div
                    *ngIf="row.Md_Status == 'T'"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-gray [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    TEIL-ERFASST
                  </div>

                  <div
                    *ngIf="row.Md_Status == 'E'"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-darkgray [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    ERFASST
                  </div>

                  <div
                    *ngIf="row.Md_Status == 'U'"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-overdue [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    ÜBERFÄLLIG
                  </div>

                  <div
                    *ngIf="row.Md_Status == 'B'"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-active-fsdone [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    BEZAHLT
                  </div>

                  <div
                    *ngIf="row.Md_Status == 'AB'"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-warn [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    ANG/BEZ
                  </div>

                  <div
                    *ngIf="row.Md_Status == 'S'"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-lightgray [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    STORNO
                  </div>

                  <div
                    *ngIf="row.Md_Status == '8'"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-warn [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    AUSGENOMMEN
                  </div>

                  <div
                    *ngIf="row.Md_Status == '9'"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-error [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    ERROR
                  </div>
                </td>
              </ng-container>

              <!-- Profilbild Column
                <ng-container matColumnDef="profile_image">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-50">&nbsp;</th>
                  <td mat-cell *matCellDef="let row">
                    <phuture-iavatar src_image="{{ imageStorage }}{{ row.profile_image }}"></phuture-iavatar>
                  </td>
                </ng-container>
                -->

              <!-- Md_BelegNr Column -->
              <ng-container matColumnDef="Md_BelegNr">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-100">Aktenzeichen</th>
                <td mat-cell *matCellDef="let row" class="font-semibold">&nbsp;{{ row.Md_BelegNr }}&nbsp;</td>
              </ng-container>

              <!-- bom Column -->
              <ng-container matColumnDef="bom">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-80">BOM</th>
                <td mat-cell *matCellDef="let row">
                  <div
                    *ngIf="row.bom == 1"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-bom [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#4caf50] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-white shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#388e3c] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    BOM
                  </div>
                  <div
                    *ngIf="row.bom == 0 || !row.bom"
                    data-te-chip-init
                    data-te-ripple-init
                    class="chip-anzeige [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#2196f3] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-white shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#1976d2] dark:bg-neutral-600 dark:text-neutral-200"
                    data-te-close="true">
                    Anzeige
                  </div>
                </td>
              </ng-container>

              <!----------------------------------------------------------------- -->

              <!-- Md_StatusDate Column -->
              <ng-container matColumnDef="Md_StatusDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Datum</th>
                <td mat-cell *matCellDef="let row">&nbsp;{{ row.Md_StatusDate | date }}&nbsp;</td>
              </ng-container>

              <!-- Md_StatusTime Column -->
              <ng-container matColumnDef="Md_StatusTime">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Zeit</th>
                <td mat-cell *matCellDef="let row">&nbsp;{{ row.Md_StatusTime | date : 'shortTime' }}&nbsp;</td>
              </ng-container>

              <!-- Md_KzLand Column -->
              <ng-container matColumnDef="Md_KzLand">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Land</th>
                <td mat-cell *matCellDef="let row">&nbsp;{{ row.Md_KzLand }}&nbsp;</td>
              </ng-container>

              <!-- Md_KzBezirk Column -->
              <ng-container matColumnDef="Md_KzBezirk">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Bezirk</th>
                <td mat-cell *matCellDef="let row">{{ row.Md_KzBezirk }}</td>
              </ng-container>

              <!-- Md_KzNummer Column -->
              <ng-container matColumnDef="Md_KzNummer">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Kennzeichen</th>
                <td mat-cell *matCellDef="let row">{{ row.Md_KzNummer }}</td>
              </ng-container>

              <!-- Md_Hersteller Column -->
              <ng-container matColumnDef="Md_Hersteller">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-100">Hersteller</th>
                <td mat-cell *matCellDef="let row">{{ row.Md_Hersteller }}</td>
              </ng-container>

              <!-- VSTV Code Column -->
              <ng-container matColumnDef="Md_TatbestNr">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>VSTV Code</th>
                <td mat-cell *matCellDef="let row">{{ formatVSTVCode(row.Md_TatbestNr) }}</td>
              </ng-container>

              <!-- Md_Betrag Column -->
              <ng-container matColumnDef="Md_Betrag">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Betrag</th>
                <td mat-cell *matCellDef="let row">{{ row.Md_Betrag }}</td>
              </ng-container>

              <!-- Person Column -->
              <ng-container matColumnDef="person">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-100">Person</th>
                <td mat-cell *matCellDef="let row">{{ row.person }}</td>
              </ng-container>

              <!----------------------------------------------------------------- -->

              <!-- actions button bar Column
              -->

              <ng-container matColumnDef="actions" stickyEnd>
                <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
                <td mat-cell *matCellDef="let row">
                  <button mat-icon-button [matMenuTriggerFor]="appMenu" (click)="$event.stopPropagation()">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #appMenu="matMenu">
                    <button mat-menu-item (click)="ausPaketAusnehmen(row)">Aus Paket ausnehmen</button>
                    <!--
                    <button mat-menu-item (click)="editItem(row)">Bearbeiten</button>
                    -->
                  </mat-menu>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumnsArchiv"></tr>
              <tr
                mat-row
                *matRowDef="let emprow; columns: displayedColumnsArchiv"
                (click)="openPreview(emprow.Md_PrimKey)"
                style="cursor: pointer"></tr>
            </table>

            <mat-paginator
              #paginator
              [hidden]="showArchivNoPaketSelected"
              [length]="totalItems"
              [pageSizeOptions]="pageSizes"
              showFirstLastButtons></mat-paginator>
          </div>

          <p>&nbsp;</p>

          <form [formGroup]="frmExportArchiv">
            <div *ngIf="selectedVSTVPaketID > 0">
              <div class="flex items-center space-x-2">
                <label for="bearbeiter" class="mr-2">Bearbeiter:</label>
                <input
                  type="text"
                  class="form-input bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-1/3 p-2.5"
                  id="bearbeiterErneut"
                  formControlName="bearbeiterErneut"
                  placeholder="Bearbeiter" />
              </div>

              <div class="mt-4">
                <button
                  *ngIf="false"
                  type="button"
                  matRipple
                  [matRippleColor]="'rgb(103, 121, 189, 0.5)'"
                  class="bg-gray-400 hover:bg-gray-700 text-white py-2 px-4"
                  [style]="{ 'margin-left': '.5em' }"
                  (click)="downloadVSTV(selectedVSTVPaketID, true)">
                  VSTV erneut downloaden
                </button>

                <button
                  *ngIf="false"
                  type="button"
                  matRipple
                  [matRippleColor]="'rgb(103, 121, 189, 0.5)'"
                  class="bg-blue-400 hover:bg-blue-700 text-white py-2 px-4"
                  [style]="{ 'margin-left': '.5em' }"
                  (click)="generateVSTV(selectedVSTVPaketID)">
                  VSTV neu erstellen
                </button>

                <button
                  type="button"
                  matRipple
                  [matRippleColor]="'rgb(103, 121, 189, 0.5)'"
                  class="text-white py-2 px-4"
                  style="background-color: rgb(89, 151, 111); border: none; border-radius: 4px; cursor: pointer; margin-left: .5em;"
                  onmouseover="this.style.backgroundColor='rgb(65, 120, 85)'"
                  onmouseout="this.style.backgroundColor='rgb(89, 151, 111)'"
                  (click)="generateVSTV25(selectedVSTVPaketID)">
                  VSTV v25 neu erstellen
                </button>

                <button
                  type="button"
                  matRipple
                  [matRippleColor]="'rgb(103, 121, 189, 0.5)'"
                  class="text-white py-2 px-4"
                  style="background-color: rgb(89, 151, 111); border: none; border-radius: 4px; cursor: pointer; margin-left: .5em;"
                  onmouseover="this.style.backgroundColor='rgb(65, 120, 85)'"
                  onmouseout="this.style.backgroundColor='rgb(89, 151, 111)'"
                  (click)="downloadVSTVImagesZip()">
                  Bilder-Archiv Link
                </button>

                <button
                  matRipple
                  [matRippleColor]="'rgba(0,0,0,0.15)'"
                  class="text-white py-2 px-4"
                  style="background-color: rgb(156, 163, 175); border: none; border-radius: 4px; cursor: pointer; margin-left: .5em; opacity: 0.85;"
                  onmouseover="this.style.backgroundColor='rgb(120, 128, 140)'; this.style.opacity='1'"
                  onmouseout="this.style.backgroundColor='rgb(156, 163, 175)'; this.style.opacity='0.85'"
                  (click)="generateVSTV25Test(selectedVSTVPaketID)">
                  Test Export
                </button>
              </div>

              <div *ngIf="vstvlog != '' && erneutDownload" class="logVSTVExport checkJournal">
                <p [innerHTML]="vstvlog"></p>

                <button
                  type="button"
                  matRipple
                  [matRippleColor]="'rgb(103, 121, 189, 0.5)'"
                  class="bg-blue-400 hover:bg-blue-700 text-white py-2 px-4"
                  [style]="{ 'margin-left': '.5em' }"
                  (click)="downloadVSTV(paketID)">
                  VSTV Datei herunterladen
                </button>
              </div>

              <div *ngIf="vstv25log != '' && erneutDownload25" class="logVSTVExport checkJournal">
                <p [innerHTML]="vstv25log"></p>

                <button
                  type="button"
                  matRipple
                  [matRippleColor]="'rgb(103, 121, 189, 0.5)'"
                  class="text-white py-2 px-4"
                  style="background-color: rgb(89, 151, 111); border: none; border-radius: 4px; cursor: pointer; margin-left: .5em;"
                  onmouseover="this.style.backgroundColor='rgb(65, 120, 85)'"
                  onmouseout="this.style.backgroundColor='rgb(89, 151, 111)'"
                  (click)="downloadVSTV25(paketID)">
                  VSTV25 XML Datei herunterladen
                </button>
              </div>
            </div>
          </form>
          <p>&nbsp;</p>
        </mat-tab>
      </mat-tab-group>

      <p>&nbsp;</p>
      </mat-card-content>
    </mat-card>
  </div>
</div>
